export const getLevel1VerificationProps = (
  verificationLevel,
  levelIncreaseStatus
) => {
  return {
    currentLevel:
      (verificationLevel === 0 && levelIncreaseStatus !== 'pass') ||
      (verificationLevel === 1 && levelIncreaseStatus === 'underReview')
  };
};

export const getLevel2VerificationProps = (
  verificationLevel,
  levelIncreaseStatus
) => {
  return {
    underReview:
      verificationLevel === 0 && levelIncreaseStatus === 'underReview',
    verified:
      verificationLevel > 0 ||
      (verificationLevel === 0 && levelIncreaseStatus === 'pass'),
    canIncrease:
      verificationLevel === 0 &&
      levelIncreaseStatus !== 'pass' &&
      levelIncreaseStatus !== 'underReview',
    currentLevel:
      (verificationLevel === 1 && levelIncreaseStatus !== 'pass') ||
      (verificationLevel === 0 && levelIncreaseStatus === 'pass')
  };
};
